export default "__VITE_ASSET__cqK10zPg__"